import { useState } from "react";
import { toast } from "sonner";
import { BACKEND_URL, errMsg, useApi } from "@/lib/api";

export const useExtensionDownload = () => {
  const api = useApi();
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const res = await api.post("/extension/download", { backend_url: BACKEND_URL }, { responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(res.data);
      a.download = "nyscef-docketzip-extension.zip";
      a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 60000);
      toast.success("Extension downloaded. It's linked to your account.");
    } catch (e) {
      toast.error(errMsg(e, "Download failed"));
    } finally {
      setBusy(false);
    }
  };
  return { download, busy };
};
